import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { apiDelete, apiGet, apiPost } from "../../lib/api";

type BlockRow = {
  id: string;
  kind: string;
  value: string;
  reason?: string | null;
  is_active: boolean;
  expires_at?: string | null;
  created_at: string;
};

export function SystemAbuseBlocklistPage() {
  const qc = useQueryClient();
  const [kind, setKind] = useState<"ip" | "ip_cidr" | "telegram_user" | "email_domain" | "country">("ip");
  const [value, setValue] = useState("");
  const [reason, setReason] = useState("");
  const [expiresAt, setExpiresAt] = useState("");
  const list = useQuery({ queryKey: ["sys-abuse-blocklist"], queryFn: () => apiGet<{ items: BlockRow[] }>("/v3/sys/abuse/blocklist") });
  const createMutation = useMutation({
    mutationFn: () => apiPost("/v3/sys/abuse/blocklist", { kind, value, reason: reason || null, expires_at: expiresAt || null }),
    onSuccess: async () => {
      setValue(""); setReason(""); setExpiresAt("");
      await qc.invalidateQueries({ queryKey: ["sys-abuse-blocklist"] });
    },
  });
  const deleteMutation = useMutation({
    mutationFn: (id: string) => apiDelete(`/v3/sys/abuse/blocklist/${id}`),
    onSuccess: async () => { await qc.invalidateQueries({ queryKey: ["sys-abuse-blocklist"] }); },
  });

  return (
    <div className="grid gap-4">
      <h1 className="text-2xl font-semibold">Abuse Blocklist</h1>
      <section className="panel p-4 grid gap-2">
        <h2 className="text-lg font-semibold">Add Block</h2>
        <div className="grid md:grid-cols-4 gap-2">
          <select className="input" value={kind} onChange={(e) => setKind(e.target.value as any)}>
            <option value="ip">ip</option><option value="ip_cidr">ip_cidr</option><option value="telegram_user">telegram_user</option><option value="email_domain">email_domain</option><option value="country">country</option>
          </select>
          <input className="input" placeholder="value" value={value} onChange={(e) => setValue(e.target.value)} />
          <input className="input" placeholder="reason" value={reason} onChange={(e) => setReason(e.target.value)} />
          <input className="input" type="datetime-local" value={expiresAt} onChange={(e) => setExpiresAt(e.target.value)} />
        </div>
        <button className="btn max-w-xs" disabled={!value.trim()} onClick={() => createMutation.mutate()}>Add / Reactivate</button>
      </section>

      <section className="panel p-4">
        <h2 className="text-lg font-semibold">Active Blocks</h2>
        <div className="grid gap-2 mt-2 text-sm">
          {(list.data?.items ?? []).map((row) => (
            <div key={row.id} className="rounded border border-slate-200 bg-white p-3 flex flex-wrap justify-between gap-2">
              <div>
                <p><strong>{row.kind}</strong>: {row.value}</p>
                <p className="text-slate-500">{row.reason || "No reason"}</p>
              </div>
              <button className="btn" onClick={() => deleteMutation.mutate(row.id)}>Remove</button>
            </div>
          ))}
          {!(list.data?.items ?? []).length ? <p className="text-slate-500">No blocks configured.</p> : null}
        </div>
      </section>
    </div>
  );
}
